import { omit } from 'lodash-es';

export const getGeneralTicketPayload = (values = {}) => {
  const { assignee, team, dueDate, priority, reason } = values;

  return {
    ...omit(values, ['ticketType']),
    customFields: {
      ...omit(values?.customFields, ['connectTicketTo']),
      carId: values?.customFields?.carId || null,
    },
    assignee: assignee?.value,
    team: team?.value,
    dueDate: dueDate || null,
    priority: priority?.value ?? 0,
    reason: reason?.value || null,
  };
};

export const getArnmMaintenanceTicketPayload = (values = {}) => {
  return {
    status: 0,
    ...omit(values, ['ticketType', 'priority', 'reason']),
    assignee: values?.assignee?.value,
    customFields: {
      ...omit(values?.customFields, ['connectTicketTo']),
      dateToServicePoint: values?.customFields?.dateToServicePoint || null,
      expectedOutFromServicePoint:
        values?.customFields?.expectedOutFromServicePoint || null,
      pipedriveId: Number(values?.customFields?.pipedriveId),
      servicePoint: values?.customFields?.servicePoint?.id,
    },
  };
};
